export default {
  firebaseApiKey: process.env.VUE_APP_FIREBASE_API_KEY as string,
  firebaseDatabaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL as string,
  firebaseProjectId: process.env.VUE_APP_FIREBASE_PROJECT_ID as string,
  firebaseAuthDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN as string,
  firebaseAppId: process.env.VUE_APP_FIREBASE_APP_ID as string,
  firebaseMeasurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID as string
}
